import axios from 'axios';

export const fetchEpicTokenResponse = async ({ oauthCode }) => {
  const params = new URLSearchParams();
  params.append('code', oauthCode);
  const response = await axios.post(
    '/mychart/generate-epic-token',
    params.toString()
  );
  return response.data;
};
